var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lazy)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image),expression:"image"}],class:_vm.classes}):_c('img',{class:_vm.classes,attrs:{"src":_vm.image}})}
var staticRenderFns = []

export { render, staticRenderFns }